/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { changePage, updatePageDetails, displayModal } from "@insticator/insticator-ui";
// component
import { selectRatingSite } from 'state/actions/ratingsState/ratingsStatus';
import { getRatingsConfig } from 'state/actions/ratingsState/configStatus';
import { getRatingsUnitCode } from 'state/actions/ratingsState/codeStatus';
import RatingsManager from 'pages/dashboard/ratings/ratingsmanager/ratingsmanager';



/* ========== ~~~~~~~~~~ RATING MANAGER : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ commentingState, ratingsState, sessionStatus, accountData }) => ({
    sites: accountData.sites,
    status: commentingState.commentingStatus.requestStatus,
    emailSentTo: commentingState.commentingStatus.commentEmailSentTo,
    requestPending: commentingState.commentingStatus.requestPending,
    selectedSite: ratingsState.ratingsStatus.selectedSite,
    accountUUID: sessionStatus.accountUUID,
    mocked: sessionStatus.mocked,
    mockupGenerator: sessionStatus.mockupGenerator,
    siteUUID: sessionStatus.siteUUID,
    ratingUnitUUID: ratingsState.configStatus.ratingUnitUUID,
    fetchingRatingsUnitCode: ratingsState.codeStatus.fetchingRatingsUnitCode,
    fetchingRatingsConfig: ratingsState.configStatus.fetchingRatingsConfig,
    ratingsState
});

const mapDispatchToProps = dispatch => ({
    selectRatingSite: site => dispatch(selectRatingSite(site)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton)),
    getRatingsConfig: (accountUUID, siteUUID, siteUrl, callback) => dispatch(getRatingsConfig(accountUUID, siteUUID, siteUrl, callback)),
    getRatingsUnitCode: siteUUID => dispatch(getRatingsUnitCode(siteUUID)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    }
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(RatingsManager));
